<template>
  <div id="nav">
    <div class="logo">
      <router-link to="/"><img src="../assets/logo.png" /></router-link>
    </div>

    <div class="menu">
      <div v-if="$store.state.menuIndex == 3 || showWhite">
        <div class="user-container" v-if="!getToken()">
          <a href="javascript:;" @click="toggleLoginCard">
            <img src="../assets/icon_user1.png" />
          </a>
          <LoginCard :visible="showLoginCard" @close="closeLoginCard" />
        </div>
        <el-dropdown
          class="user_dropdown"
          @command="handleCommand"
          v-else
          trigger="click"
          :hide-on-click="false"
          ref="dropdown"
        >
          <a href="javascript:;"><img src="../assets/icon_user.png" /></a>
          <el-dropdown-menu slot="dropdown" v-if="getToken()">
            <!-- <el-dropdown-item command="/user"
              ><i class="u_user"></i>{{$t('userMenu.profile')}}</el-dropdown-item
            > -->
            <el-dropdown-item command="/subscription"
              ><i class="u_sub"></i>{{$t('userMenu.subscription')}}</el-dropdown-item
            >
            <el-dropdown-item command="/user/promotion"
              ><i class="u_tg"></i>{{$t('userMenu.promotion')}}</el-dropdown-item
            >
            <el-dropdown-item command="/help"
              ><i class="u_qs"></i>{{$t('userMenu.help')}}</el-dropdown-item
            >
            <el-dropdown-item command="/user/order"
              ><i class="u_od"></i>{{$t('userMenu.order')}}</el-dropdown-item
            >
            <el-dropdown-item command="/wallet"
              ><i class="u_wallet"></i>{{$t('userMenu.wallet')}}</el-dropdown-item
            >
            <el-dropdown-item command="/user/coupons"
              ><i class="u_coupon"></i>{{$t('userMenu.coupons')}}</el-dropdown-item
            >
            <el-dropdown-item>
              <i class="u_lang"></i>{{$t('userMenu.changeLang')}}
              <div class="switch_lang">
                <ChangeLanguage/>
              </div>
            </el-dropdown-item>
            <el-dropdown-item
              ><a class="logout" @click="logout">{{$t('userMenu.logout')}}</a></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <img src="../assets/menu1.png" alt="" @click="drawer = true" />
      </div>
      <div v-else>
        <div class="user-container" v-if="!getToken()">
          <a href="javascript:;" @click="toggleLoginCard">
            <img src="../assets/icon_user.png" />
          </a>
          <LoginCard :visible="showLoginCard" @close="closeLoginCard" />
        </div>
        <el-dropdown
          class="user_dropdown"
          v-else
          @command="handleCommand"
          :hide-on-click="false"
          ref="dropdown"
          trigger="click"
        >
          <a href="javascript:;"><img src="../assets/icon_user.png" /></a>
          <el-dropdown-menu slot="dropdown" v-if="getToken()" >
            <!-- <el-dropdown-item command="/user"
              ><i class="u_user"></i>{{$t('userMenu.profile')}}</el-dropdown-item
            > -->
            <el-dropdown-item command="/subscription"
              ><i class="u_sub"></i>{{$t('userMenu.subscription')}}</el-dropdown-item
            >
            <el-dropdown-item command="/user/promotion"
              ><i class="u_tg"></i>{{$t('userMenu.promotion')}}</el-dropdown-item
            >
            <el-dropdown-item command="/help"
              ><i class="u_qs"></i>{{$t('userMenu.help')}}</el-dropdown-item
            >
            <el-dropdown-item command="/user/order"
              ><i class="u_od"></i>{{$t('userMenu.order')}}</el-dropdown-item
            >
            <el-dropdown-item command="/wallet"
              ><i class="u_wallet"></i>{{$t('userMenu.wallet')}}</el-dropdown-item
            >
            <el-dropdown-item command="/user/coupons"
              ><i class="u_coupon"></i>{{$t('userMenu.coupons')}}</el-dropdown-item
            >
            <el-dropdown-item>
              <i class="u_lang"></i>{{$t('userMenu.changeLang')}}
              <div class="switch_lang">
                <ChangeLanguage/>
              </div>
              </el-dropdown-item>
            <el-dropdown-item
              ><a class="logout" @click="logout">{{$t('userMenu.logout')}}</a></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <img src="../assets/menu.png" alt="" @click="drawer = true" />
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      custom-class="drawer-box"
    >
      <template slot="title">
        <div class="logo">
          <img src="../assets/logo.png" />
        </div>
      </template>
      <div class="drawer">
        <ul>
          <li @click="goTo('/')">{{$t('nav.home')}}</li>
          <li @click="goTo('/dealer')">{{$t('nav.dealer')}}</li>
          <li @click="goTo('/help')">{{$t('nav.help')}}</li>
          <li @click="goTo('/subscription')">{{$t('nav.subscription')}}</li>
          <li v-if="getToken()" class="divider"></li>
          <li v-if="getToken()" @click="goTo('/user/order')">{{$t('userMenu.order')}}</li>
          <li v-if="getToken()" @click="goTo('/user/promotion')">{{$t('userMenu.promotion')}}</li>
          <li v-if="getToken()" @click="goTo('/wallet')">{{$t('userMenu.wallet')}}</li>
          <li v-if="getToken()" @click="goTo('/user/coupons')">{{$t('userMenu.coupons')}}</li>
        </ul>
      </div>
    </el-drawer>
    <!-- 设置密码弹窗 -->
    <SetPasswordModal
      :visible="$store.state.user.showSetPasswordModal"
      :email="$store.state.user.setPasswordModalEmail"
      @close="handlePasswordModalClose"
      @success="handlePasswordModalSuccess"
      @skip="handlePasswordModalSkip"
    />
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { resolveLoginRedirectPath } from "@/utils/login";
import LoginCard from "./LoginCard.vue";
import SetPasswordModal from "./SetPasswordModal.vue";
import ChangeLanguage from "./i18n/ChangeLanguage.vue";
export default {
  name: "NavH",
  components: {
    LoginCard,
    SetPasswordModal,
    ChangeLanguage
  },
  data() {
    return {
      drawer: false,
      showWhite: false,
      showLoginCard: false,
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.showWhite =
          val.path.includes("user") ||
          val.path.includes("coupon-hall") ||
          val.path.includes("coupon-center") ||
          val.path.includes("/index/detail") ||
          val.path.includes("/dealer/detail") ||
          val.path.includes("/help/detail");
      },
      deep: true,
    },
  },
  mounted() {
    this.$bus.$on("close-login-card", this.closeLoginCard);
  },
  beforeDestroy() {
    this.$bus.$off("close-login-card", this.closeLoginCard);
  },
  methods: {
    getToken,
    toggleLoginCard() {
      this.showLoginCard = !this.showLoginCard;
    },
    closeLoginCard() {
      this.showLoginCard = false;
    },
    handleCommand(command) {
      if (command) {
        if (command !== this.$route.path) {
          this.$refs.dropdown.hide();
          this.$router.push({ path: command });
        }
      }
    },
    async logout() {
      this.$confirm(this.$t('auth.confirmLogout'), this.$t('auth.confirmTitle'), {
        confirmButtonText: this.$t('auth.ok'),
        cancelButtonText: this.$t('auth.cancel'),
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("FedLogOut").then(() => {
            location.href = "/";
          });
        })
        .catch(() => {});
    },
    handleClose() {
      this.drawer = false;
    },
    goTo(path) {
      this.drawer = false;
      if (path !== this.$route.path) {
        this.$router.push(path);
      }
    },
    getPostLoginRedirectPath() {
      return resolveLoginRedirectPath(this.$route.query.redirect, "/");
    },
    handlePasswordModalClose() {
      this.$store.dispatch("hideSetPasswordModal");
      this.$router.push(this.getPostLoginRedirectPath());
    },
    handlePasswordModalSuccess() {
      this.$store.dispatch("hideSetPasswordModal");
      this.$router.push(this.getPostLoginRedirectPath());
    },
    handlePasswordModalSkip() {
      this.$store.dispatch("hideSetPasswordModal");
      this.$router.push(this.getPostLoginRedirectPath());
    },
  },
};
</script>

<style lang="scss" scoped>
#nav {
  width: 100%;
  padding: 12px 15px;
  box-sizing: border-box;
  display: flex;
  position: absolute;
  z-index: 2100;
  align-content: center;
  justify-content: space-between;
  .logo {
    a {
      img {
        height: 20px;
      }
    }
  }
  .menu {
    position: relative;
    .user-container {
      position: relative;
      display: inline-block;
      a {
        margin-right: 12px;
        img {
          height: 25px;
        }
      }
    }
    a {
      margin-right: 12px;
      img {
        height: 25px;
      }
    }
    img {
      height: 19px;
    }
  }
}
.switch_lang{
  width: 150px;
  left: -150px;
  background-color: white;
  position: absolute;
  margin-top: -36px;
  display: none;
  box-shadow: 0 5px 6px -3px #0003, 0 9px 12px 1px #00000024, 0 3px 16px 2px #0000001f;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
}
::v-deep .drawer-box {
  width: 100vw !important;
  //   padding: 0 !important;
  .logo {
    img {
      height: 20px;
    }
  }

  ul {
    margin-top: -20px;
    padding: 0 30px;
    li {
      padding: 25px 0px;
      border-bottom: 1px solid #e3e3e3;
      
      &.divider {
        padding: 0;
        margin: 10px 0;
        border-bottom: 2px solid #1d3fff;
        background: transparent;
      }
    }
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    margin: 8px 0;
    &:last-child:hover {
      background-color: white;
    }
    &:hover{
      .switch_lang{
        display: block;
      }
    }
  }
  .u_user {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_user.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_sub {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_sub.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_tg {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_tg.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_qs {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_qs.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_od {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_od.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_wallet {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_tg.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_coupon {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/coupon.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .u_lang {
    display: inline-block;
    width: 18px;
    height: 18px;
    background: url(../assets/u_lang.png) no-repeat center;
    background-size: 80%;
    vertical-align: middle;
    margin-bottom: 4px;
  }
  .logout {
    display: block;
    width: 90px;
    text-align: center;
    margin: 0 auto;
    background: #eaeaea;
    border-radius: 17px 17px 17px 17px;
    height: 34px;
    line-height: 34px;
  }
}
</style>
